import Vue from "vue";
import {
  ObjectEx
} from "vue-objectex";

export class EmailVideo extends ObjectEx {
  constructor() {
    let options = [{
        key: "Id",
        value: 0,
      },
      {
        key: "CourseActivationId",
        value: null,
      },
      {
        key: "VideoPlatform",
        value: 1,
      },
      {
        key: "Title",
        value: null,
      },
      {
        key: "CourseType",
        value: null,
      },
      {
        key: "CourseId",
        value: null,
      },
      {
        key: "CourseActivationId",
        value: null,
      },
      {
        key: "CampusId",
        value: null,
      },
      {
        key: "ExpirationTime",
        value: null,
      },
      {
        key: "VideoFileId",
        value: null,
      },
      {
        key: "Files",
        value: []
      },
      {
        key: "Students",
        value: []
      }
    ];

    let funcExtensions = {
      updateByBackendData(data) {
        this.Id = data.Id;
        this.CourseActivationId = data.CourseActivationId;
        this.VideoPlatform = data.VideoPlatform;
        this.Title = data.Title;
        this.CourseType = data.CourseType;
        this.CourseId = data.CourseId;
        this.CampusId = data.CampusId;
        this.CourseActivationId = data.CourseActivationId;
        this.ExpirationTime = data.ExpirationTime;
        this.VideoFileId = data.VideoFileId;
        this.Files = Object.clone(data.Files);
        this.Students = Object.clone(data.Students);
      }
    };

    let defineProps = {
      CourseKey: {
        get() {
          if (this.CourseType === 3) return `${this.CourseId}-${this.CampusId}`;

          return `${this.CourseId || String.empty}`;
        },
        set(value) {
          if (!!value) {
            let splitValues = value.split("-");
            this.CourseId =
              splitValues.length > 0 ? splitValues[0].toNumber() : null;
            this.CampusId =
              splitValues.length > 1 ? splitValues[1].toNumber() : null;
          } else {
            this.CourseId = null;
            this.CampusId = null;
          }
        },
      },
    };

    super(options, funcExtensions, defineProps);
  }
}



// WEBPACK FOOTER //
// ./src/model/emailVideo.js